import { autenticado, saveReturnUrl } from "helpers/auth-functions";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { BusinessState } from "redux-context/business";
import { UserState } from "redux-context/user";

const AuthenticationGuard: React.FC<any> = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const businessId = searchParams.get("businessId");

  const { loggedUser, loading } = useSelector((state: UserState) => state.user);
  const { businessess, loadingBusinessess } = useSelector(
    (state: BusinessState) => state.business
  );

  const isAuthenticated = autenticado();

  if (
    businessId &&
    !loading &&
    !loadingBusinessess &&
    !loggedUser?.roles?.includes("admin")
  ) {
    if (!businessess.some((business) => business.businessId === businessId)) {
      return <Navigate to="/" replace />;
    }
  }

  if (!isAuthenticated) {
    if (window.location.pathname !== "/login") {
      saveReturnUrl();
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default AuthenticationGuard;
